import { render, staticRenderFns } from "./Alarm.vue?vue&type=template&id=46dc3fba"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46dc3fba')) {
      api.createRecord('46dc3fba', component.options)
    } else {
      api.reload('46dc3fba', component.options)
    }
    module.hot.accept("./Alarm.vue?vue&type=template&id=46dc3fba", function () {
      api.rerender('46dc3fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/invoice/Alarm.vue"
export default component.exports